import handleAddToBox from "../../src/js/components/addToBox";
import utils from "../../src/js/utils";

const documentation = {
    init() {
        document.querySelectorAll('.documentation').forEach(section => {
            this.loadMoreDocuments(section);
            this.searchForDocuments(section);
            this.handleSelectedRows(section);

            handleAddToBox.init(section);

            section.querySelectorAll('.documentation__header__filters__single').forEach(filter => {
                this.handleSelect(filter, section);
            });

            section.querySelectorAll('.documentation__header__filters__single__options__single[for^="product-line"]').forEach(product_line => {
                product_line.addEventListener('click', () => {
                    setTimeout(() => {
                        const selected_product_lines = section.querySelectorAll('.documentation__header__filters__single__options__single[for^="product-line"]:has(input:checked)');

                        let classes = [];

                        selected_product_lines.forEach(productLine => {
                            let classList = productLine.getAttribute('class');
                            classList = classList.replace('documentation__header__filters__single__options__single', '');
                            classList = classList.trim();
                            classes.push(classList);
                        });

                        section.querySelectorAll('.documentation__header__filters__single__options__single[for^="product-category"]').forEach(category => {
                            let classList = category.getAttribute('class');
                            classList = classList.replace('documentation__header__filters__single__options__single', '');
                            classList = classList.replace('hidden', '');
                            classList = classList.trim();

                            if (classes.includes(classList) || classes.length === 0) {
                                category.classList.remove('hidden');
                            } else {
                                category.classList.add('hidden');
                                if (category.querySelector('input:checked')) {
                                    category?.click();
                                }
                            }
                        });
                    }, 50);
                });
            });

            section.querySelectorAll('.documentation__header__filters__single__options__single').forEach(option => {
                option.addEventListener('click', () => {
					const input = option.querySelector('input');
					input.checked = !input.checked;
                    this.hideDocumentsWhenLoadin(section);
                    this.updateActiveFilters(section);
                });
            });

            section.querySelectorAll('.documentation__header__filters__single__options').forEach(options => {
                options.addEventListener('click', utils.debounce(() => {
                    this.reloadDocuments(section);
                }, 500));
            });

            section.querySelector('button#clear-all-filters').addEventListener('click', () => {
                section.querySelectorAll('.documentation__header__active_filters__filters__single__remove_button').forEach(button => {
                    const option = button.getAttribute('data-option');
                    const input = section.querySelector(`#${option}`);
                    input.checked = false;
                });

                this.updateActiveFilters(section);
                this.hideDocumentsWhenLoadin(section);
                this.reloadDocuments(section);
            });

            section.querySelector('#download-selected-files').addEventListener('click', () => {
                const documentRows = section.querySelectorAll('input[name="selected_documents"]:checked');

                const attachments = [];

                documentRows.forEach(documentRow => {
                    const all_languages = section.querySelectorAll(`[name^="document-language-${documentRow.value}"]`);
                    all_languages.forEach(attachment => {
                        attachments.push(attachment.value);
                    });
                });

                window.open(`${documentation_php.documents_endpoint}?selected_documents=${attachments.join(',')}`);
            });

            section.querySelector('#add-to-download-box').addEventListener('click', () => {
                const productLines = section.querySelectorAll('input[name="selected_documents"]:checked');
                const documents = [...productLines].map(productLine => productLine.value);

                handleAddToBox.addToBox(documents, 'boxed_documents');
            })

            section.querySelector('.documentation__header__title_and_search__filters_button').addEventListener('click', () => {
                section.querySelector('.documentation__header__filters').classList.toggle('active');
            });

            section.querySelector('.documentation__header__filters').addEventListener('click', (e) => {
                e.stopImmediatePropagation();

                if (!section.querySelector('.documentation__header__filters.active')?.contains(e.target)) {
                    section.querySelector('.documentation__header__filters').classList.remove('active');
                }
            });

            section.querySelectorAll('.documentation__header__filters__overlay, #close-filters').forEach(button => {
                button.addEventListener('click', () => {
                    section.querySelector('.documentation__header__filters').classList.remove('active');
                });
            });
        });
    },

    handleSelectedRows(section) {
        section.querySelectorAll('.document_row__name').forEach(row => {
            row.addEventListener('click', () => {
                const checkboxes = section.querySelectorAll('.document_row__name input:checked');
                const download_section = section.querySelector('.documentation__download');

                section.querySelectorAll('.documentation__download__button .count').forEach(count => {
                    count.innerHTML = '(' + checkboxes.length + ')';
                });

                if (checkboxes.length > 0) {
                    download_section.classList.add('active');
                } else {
                    download_section.classList.remove('active');
                }
            });
        });
    },

    hideDocumentsWhenLoadin(section) {
        const button = section.querySelector('#load-more-button');

        if (!section.querySelector('#documents-wrapper #loading')) {
            section.querySelector('#documents-wrapper').innerHTML = '<div id="loading"></div>';
            button?.classList.add('hidden');
        }
    },

    reloadDocuments(section) {
        const button = section.querySelector('#load-more-button');

        this.handleSearch(section, 1, (response) => {
            section.querySelector('#documents-wrapper').innerHTML = response.data.html;
            button?.setAttribute('data-loaded-page', 1);
        });
    },

    searchForDocuments(section) {
        const input = section.querySelector('#search-for-documents');

        if (!input) {
            return;
        }

        input.addEventListener('input', () => {
            this.hideDocumentsWhenLoadin(section);
        });

        input.addEventListener('input', utils.debounce(() => {
            this.reloadDocuments(section);
        }, 500));
    },

    updateActiveFilters(section) {
        const active_filters = section.querySelectorAll('.documentation__header__filters__single__options__single input:checked');

        this.updateActiveFiltersCount(active_filters, section);

        const filters = section.querySelector('.documentation__header__active_filters');

        filters.querySelectorAll('.documentation__header__active_filters__filters__single').forEach(filter => {
            filter.remove();
        });

        if (active_filters.length !== 0) {
            section.querySelector('.documentation__header__active_filters').classList.add('active');
        } else {
            section.querySelector('.documentation__header__active_filters').classList.remove('active');
        }

        active_filters.forEach(filter => {
            const filter_id = filter.getAttribute('id');
            const filter_label = section.querySelector(`label[for="${filter_id}"]`).innerText;

            const newFilter = document.createElement('div');

            newFilter.classList.add('documentation__header__active_filters__filters__single');

            newFilter.innerHTML = `
                <span class="text-base">${filter_label}</span>
                <button data-option="${filter_id}" class="documentation__header__active_filters__filters__single__remove_button">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"
                        fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round"
                        stroke-linejoin="round"
                    >
                        <line x1="18" y1="6" x2="6" y2="18"></line>
                        <line x1="6" y1="6" x2="18" y2="18"></line>
                    </svg>
                </button>
            `;

            filters.insertBefore(newFilter, filters.querySelector('#clear-all-filters'));
        });

        section.querySelectorAll('.documentation__header__active_filters__filters__single__remove_button').forEach(button => {
            button.addEventListener('click', () => {
                const option = button.getAttribute('data-option');
                const input = section.querySelector(`#${option}`);
                input.checked = false;
                this.updateActiveFilters(section);
                this.hideDocumentsWhenLoadin(section);
            });

            button.addEventListener('click', utils.debounce(() => {
                this.reloadDocuments(section);
            }, 1000));
        });
    },

    updateActiveFiltersCount(active_filters, section) {
        const count = active_filters.length ?? 0;

        if (count > 0) {
            section.querySelector('#active-filters-count').classList.add('active');
            section.querySelector('#active-filters-count').innerText = count;
        } else {
            section.querySelector('#active-filters-count').classList.remove('active');
        }

        section.querySelectorAll('.documentation__header__filters__single').forEach(filter => {
            const checked_options = filter.querySelectorAll('.documentation__option__checkbox__input:checked');
            const label = filter.querySelector('.documentation__header__filters__single__label_wrapper__label p');

            label.parentNode.querySelector('span')?.remove();

            if (checked_options.length > 0) {
                label.outerHTML = label.outerHTML + `<span>(${checked_options.length})</span>`;
            }
        });
    },

    handleSearch(section, page_to_load, response_handler) {
        if (page_to_load === 1) {
            section.querySelector('.documentation__download').classList.remove('active');
        }

        const productLines = section.querySelectorAll('.documentation__option__checkbox__input[name="product-line"]:checked');
        const productCategories = section.querySelectorAll('.documentation__option__checkbox__input[name="product-category"]:checked');
        const documentTypes = section.querySelectorAll('.documentation__option__checkbox__input[name="document-type"]:checked');
        const selectedLanguages = section.querySelectorAll('.documentation__option__checkbox__input[name="language"]:checked');

        const values = (elements) => {
            return Array.from(elements).map(element => element.value).join(',');
        };

        const search_query = section.querySelector('#search-for-documents');
		const filter_ids   = section.getAttribute('data-filter') ?? 0;

        const data = new FormData();
        data.append('action', 'search_for_documents');
        data.append('nonce', documentation_php.nonce);
        data.append('search_query', search_query.value ?? '');
        data.append('product_lines', values(productLines));
        data.append('product_categories', values(productCategories));
        data.append('document_types', values(documentTypes));
        data.append('languages', values(selectedLanguages));
        data.append('filter_ids', filter_ids);
        data.append('page_to_load', page_to_load);

        fetch(documentation_php.ajax_url, {
            method: "POST",
            credentials: 'same-origin',
            body: data
        })
            .then(response => response.json())
            .then(response => {
                response_handler(response)

                const button = section.querySelector('#load-more-button');
                if (!button) {
                    return;
                }

                button.classList.remove('hidden');
                button.classList.remove('loading');

                if (response.data.is_last_page) {
                    button.classList.add('hidden');
                }

                window.document_row.init();
                this.handleSelectedRows(section);
                handleAddToBox.init(section);
            })
            .catch((error) => {
                console.log('[SEARCH FOR DOCUMENTS]');
                console.error(error);
            });
    },

    loadMoreDocuments(section) {
        const button = section.querySelector('#load-more-button');

        if (!button) {
            return;
        }

        button.addEventListener('click', () => {
            button.classList.add('loading');

            const nextPage = parseInt(button.getAttribute('data-loaded-page')) + 1;
            this.handleSearch(section, nextPage, (response) => {
                section.querySelector('#documents-wrapper').insertAdjacentHTML('beforeend', response.data.html);
                button.setAttribute('data-loaded-page', nextPage);
            });
        });
    },

    handleSelect(element, section) {
        if (!element) {
            return;
        }

        element.addEventListener('click', (e) => {
            e.stopImmediatePropagation();

            if (element.classList.contains('active')) {
                element.classList.remove('active');
                return;
            }

            section.querySelectorAll('.documentation__header__filters__single').forEach(filter => {
                filter.classList.remove('active');
            });

            section.querySelectorAll('.document_row__language').forEach(language_select => {
                language_select.classList.remove('active');
            });

            element.classList.toggle('active');
        });

        document.addEventListener('click', (event) => {
            if (!element.contains(event.target)) {
                element.classList.remove('active');
            }
        });
    }
}

document.addEventListener('DOMContentLoaded', () => {
    documentation.init();
});
